<template>
  <div class="payment-detail-report">
    <v-progress-linear v-if="isLoading" indeterminate height="3" />

    <v-data-table
      v-else
      dense
      readonly
      :sort-by="sortBy"
      sort-desc
      :mobile-breakpoint="0"
      :headers="headers"
      :items-per-page="-1"
      hide-default-footer
      :items="PaymentDetail"
      class="payment-detail-table"
    >
      <template v-slot:item.createdAt="{ item }">
        {{ item.createdAt | moment("MM/DD/YYYY") }}
      </template>

      <template v-slot:item.customer="{ item }">
        <span v-if="item.Invoice && item.Invoice.Customer">
          {{ item.Invoice.Customer.name }}
        </span>
        <span v-else>N/A</span>
      </template>

      <template v-slot:item.invoice="{ item }">
        <span v-if="item.Invoice">
          {{ item.Invoice.localId }}
        </span>
        <span v-else>N/A</span>
      </template>

      <template v-slot:item.amount="{ item }">
        <span class="money">
          {{ item.amount | currency }}
        </span>
      </template>

      <template v-slot:no-data>
        <div class="empty-state">
          No payment details found.
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import paymentService from "@/modules/Customer/Payment/service.js";

export default {
  name: "payment-detail-report",

  props: ["PaymentId"],

  data() {
    return {
      isLoading: true,
      PaymentDetail: [],
      sortBy: "createdAt",
      headers: [
        {
          text: "Date",
          align: "left",
          value: "createdAt",
          sortable: true,
        },
        {
          text: "Customer",
          align: "left",
          value: "customer",
          sortable: true,
        },
        {
          text: "Invoice",
          align: "right",
          value: "invoice",
          sortable: true,
        },
        {
          text: "Amount",
          align: "right",
          value: "amount",
          sortable: true,
        },
      ],
    };
  },

  async created() {
    await this.getPaymentDetail();
  },

  computed: {
    exportRows() {
      return this.PaymentDetail.map((item) => ({
        date: item.createdAt,
        paymentMethod: "",
        customerName:
          item.Invoice && item.Invoice.Customer ? item.Invoice.Customer.name : "",
        invoice: item.Invoice ? item.Invoice.localId : "",
        amount: Number(item.amount || 0),
      }));
    },
  },

  methods: {
    async getPaymentDetail() {
      this.isLoading = true;

      try {
        const response = await paymentService.getDetailById(this.PaymentId);

        this.PaymentDetail = response.data || [];
        this.$emit("export-data", this.exportRows);
      } finally {
        this.$Progress.finish();
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.payment-detail-report {
  background: #fff;
}

.payment-detail-table ::v-deep th {
  font-size: 12px;
  font-weight: 700;
  color: #374151 !important;
  background: #fff;
  text-transform: uppercase;
}

.payment-detail-table ::v-deep td {
  font-size: 13px;
}

.money {
  font-weight: 700;
}

.empty-state {
  padding: 24px;
  text-align: center;
  color: #6b7280;
}

@media print {
  .no-print {
    display: none !important;
  }
}
</style>